module.exports = __webpack_public_path__ + "static/media/13.537a5023.png";